import React, { useEffect, useRef, useState } from 'react';
import { monaco } from 'react-monaco-editor';

import { baseFileSelector } from '../../features/builder/baseFileSelector';

const menuItemClassNames =
  'builder-flex builder-items-center builder-gap-2.5 builder-w-full builder-px-2.5 builder-py-2 builder-text-sm builder-text-left builder-text-slate-800 builder-rounded-md hover:builder-bg-slate-100 focus:builder-outline-none focus-visible:builder-bg-slate-100';

const FileUploaderBase = ({ url, handleFileUpload, handleSelectExistingFile, loading, editorRef, buttonClassName }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef();

  useEffect(() => {
    if (url) {
      //Looks weird but is to insert it in multiple lines
      const imageElement = `<img
  src='${url}'
  alt='uploaded image'/>`;
      const currentPosition = editorRef.current.editor.getPosition();
      editorRef.current.editor.getModel().applyEdits([
        {
          range: monaco.Range.fromPositions(currentPosition),
          text: imageElement
        }
      ]);
    }
  }, [url]);

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div ref={containerRef} className='builder-relative'>
      <button type='button' aria-expanded={open} onClick={() => setOpen((prevValue) => !prevValue)} className={`${buttonClassName} ${open ? 'builder-bg-white/10 builder-text-white' : ''}`}>
        <i className={loading ? 'far fa-spinner-third fa-spin' : 'fal fa-image'} />
        Image
        <i className='fal fa-chevron-down builder-text-[11px]' />
      </button>
      {open && (
        <div className='builder-absolute builder-right-0 builder-top-10 builder-z-9999 builder-flex builder-flex-col builder-w-64 builder-p-1 builder-bg-white builder-border builder-border-slate-200 builder-rounded-lg builder-shadow-xl'>
          <button
            type='button'
            className={menuItemClassNames}
            onClick={(event) => {
              setOpen(false);
              handleSelectExistingFile(event);
            }}
          >
            <i className='fal fa-th-large builder-w-4 builder-text-slate-500' />
            Choose from media library
          </button>
          <button
            type='button'
            className={menuItemClassNames}
            onClick={(event) => {
              setOpen(false);
              handleFileUpload(event);
            }}
          >
            <i className='fal fa-upload builder-w-4 builder-text-slate-500' />
            Upload new image
          </button>
        </div>
      )}
    </div>
  );
};
export default baseFileSelector(FileUploaderBase, 'image');
